<template>
  <v-form style="width: 100%" v-model="valid" ref="form" lazy-validation id="contact">
    <v-container grid-list-lg fluid>
      <v-layout row wrap v-show="!sent">
        <v-flex xs10 offset-xs1 md8 offset-md2 lg8 offset-lg2 class="text-xs-center">
          <h2 class="white--text shadow headline">Have any questions? Please feel free to contact me:</h2>
        </v-flex>

        <v-flex xs10 offset-xs1 md6 offset-md3 lg4 offset-lg4>
          <v-text-field dark label="Name" v-model="name" :rules="nameRules" required>
          </v-text-field>
        </v-flex>

        <v-flex xs10 offset-xs1 md6 offset-md3 lg4 offset-lg4>
          <v-text-field dark label="E-mail" v-model="email" :rules="emailRules" required>
          </v-text-field>
        </v-flex>

        <v-flex xs10 offset-xs1 md6 offset-md3 lg4 offset-lg4>
          <v-textarea dark label="Message" v-model="message" :rules="messageRules" required>
          </v-textarea>
        </v-flex>

        <v-flex xs6 md3 offset-md3 class="text-xs-center">
          <v-btn @click="clear" outline color="white">Clear</v-btn>
        </v-flex>

        <v-flex xs6 md3 class="text-xs-center">
          <v-btn @click="submit" :loading="sendProgress" color="info">
            Send
            <span slot="loader">Sending...</span>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout row wrap v-show="sent">
        <v-flex xs12 class="text-xs-center">
          <h2 class="white--text">Thanks for your message!</h2>
          <h3>I'll answer you ASAP :)</h3>
        </v-flex>

        <v-flex xs12 class="text-xs-center">
          <v-btn @click="sendNew" outline color="white">Send one more</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <status-bar :statusMessage="statusMessage" />
  </v-form>
</template>

<script>
import axios from 'axios';

import StatusBar from './StatusBar';

export default {
  name: 'AskForm',
  components: {
    'status-bar': StatusBar,
  },
  data: () => ({
    valid: true,
    sent: false,
    name: '',
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 2 ? 'Name must be long than 2 characters' : true),
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || // eslint-disable-line
        'E-mail must be valid',
    ],
    message: '',
    messageRules: [v => !!v || 'Message is required'],
    sendProgress: false,
    statusMessage: null,
  }),
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.sendProgress = true;

        // Native form submission i s not yet supported
        axios
          .post('/api/submit', {
            name: this.name,
            email: this.email,
            message: this.message,
          })
          .then(() => {
            this.sendProgress = false;
            this.sent = true;
          })
          .catch(error => {
            this.sendProgress = false;
            this.sent = false;
            if (error.response && error.response.status) {
              //
            }

            console.error(error); // eslint-disable-line no-console
            this.statusMessage = {
              text: 'Oops... Something went wrong :(',
              type: 'error',
            };
          });
      }
    },
    clear() {
      this.$refs.form.reset();
    },
    sendNew() {
      this.clear();
      this.sent = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AskForm.vue